module.exports = __webpack_public_path__ + "static/media/Kite.19a44115.svg";